import { LegalLayout, Sez } from "@/components/LegalLayout";
import { useSeo } from "@/hooks/useSeo";

const ROWS = [
  ["di_cookie_consent", "Tecnico", "Memorizza la tua scelta sui cookie", "12 mesi"],
  ["access_token / refresh_token", "Tecnico", "Sessione dell'area riservata", "12 ore / 7 giorni"],
  ["Cookie di statistica", "Statistico", "Misurazione anonima delle visite", "Fino a 12 mesi"],
];

export default function CookiePolicy() {
  useSeo({
    title: "Cookie Policy — DonnaImpresa",
    description:
      "Cookie policy di DonnaImpresa: elenco dei cookie tecnici e statistici utilizzati, finalità, durata e come gestire il consenso.",
    path: "/cookie-policy",
  });

  return (
    <LegalLayout title="Cookie policy" updated="Giugno 2026" testId="cookie-policy-page">
            <Sez titolo="Titolare del trattamento">
        <p>
          Il titolare del trattamento dei dati raccolti tramite i cookie è{" "}
          <strong>BC NEXT S.r.l. — IT Consulting</strong>, Via Francesco
          Brighindi 37, 03100 Frosinone (FR), P.IVA 03291880601, telefono +39
          392 079 8266, email{" "}
          <a href="mailto:info@bcnext.it" className="di-underline text-[#5E2A52]">
            info@bcnext.it
          </a>
          . Per il trattamento dei dati inviati tramite i moduli consulta la{" "}
          <a href="/privacy" className="di-underline text-[#5E2A52]">
            privacy policy
          </a>
          .
        </p>
      </Sez>

      <Sez titolo="Cosa sono i cookie">
        <p>
          I cookie sono piccoli file di testo salvati sul tuo dispositivo che
          permettono al sito di funzionare correttamente e di ricordare alcune
          preferenze.
        </p>
      </Sez>

      <Sez titolo="Cookie utilizzati">
        <div className="overflow-x-auto rounded-2xl border border-[#E8E2E4] bg-white">
          <table className="w-full text-left text-sm" data-testid="cookie-table">
            <thead className="bg-[#FAF5F6] text-xs uppercase tracking-wider text-[#5E2A52]">
              <tr>
                <th className="px-5 py-3">Nome</th>
                <th className="px-5 py-3">Tipo</th>
                <th className="px-5 py-3">Finalità</th>
                <th className="px-5 py-3">Durata</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((r) => (
                <tr key={r[0]} className="border-t border-[#E8E2E4]">
                  {r.map((c, i) => (
                    <td key={i} className="px-5 py-3">
                      {c}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Sez>

      <Sez titolo="Gestione del consenso">
        <p>
          Al primo accesso puoi scegliere tra "Solo necessari" e "Accetta
          tutti". Per modificare la scelta è sufficiente cancellare i dati del
          sito dal tuo browser: il banner verrà mostrato di nuovo.
        </p>
      </Sez>

      <Sez titolo="Nessun tracciamento pubblicitario">
        <p>
          Non utilizziamo cookie di profilazione pubblicitaria né condividiamo
          dati con circuiti di advertising. I contenuti Instagram sono mostrati
          come immagini e link, senza script di tracciamento di terze parti.
        </p>
      </Sez>

      <Sez titolo="Cookie di terze parti">
        <p>
          I contenuti social sono presentati come link esterni: non installiamo
          widget di tracciamento di Instagram direttamente sul sito.
        </p>
      </Sez>
    </LegalLayout>
  );
}
